import waterFallVertex from '../shader/waterfall.vertex.glsl';
import waterFallFragment from '../shader/waterfall.fragment.glsl';
import waterVertex from '../shader/water.vertex.glsl';
import waterFragment from '../shader/water.fragment.glsl';

import * as THREE from 'three';
import { DRACOLoader, GLTFLoader } from 'three/examples/jsm/Addons.js';

class WaterFall {
  constructor() {
    this.gltfLoader = new GLTFLoader();
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.6/');
    this.gltfLoader.setDRACOLoader(dracoLoader);

    this.textureLoader = new THREE.TextureLoader();
  }


  async init() {
    const perlinTexture = this.textureLoader.load('/texture/perlin.png')
    perlinTexture.wrapS = THREE.RepeatWrapping;
    perlinTexture.wrapT = THREE.RepeatWrapping;
    
    const voirnoiTexture = this.textureLoader.load('/texture/vornoi.png')
    voirnoiTexture.wrapS = THREE.RepeatWrapping;
    voirnoiTexture.wrapT = THREE.RepeatWrapping;

    this.waterFallMaterial = new THREE.ShaderMaterial({
          vertexShader: waterFallVertex,
          fragmentShader: waterFallFragment,
          uniforms: {
            uTime: new THREE.Uniform(0),
            uPerlin: new THREE.Uniform(perlinTexture),
          }
        });
    
    this.waterMaterial = new THREE.ShaderMaterial({
          vertexShader: waterVertex,
          fragmentShader: waterFragment,
          uniforms: {
            uTime: new THREE.Uniform(0),
            uPerlin: new THREE.Uniform(perlinTexture),
            uVornoi: new THREE.Uniform(voirnoiTexture),
          }
        });

    const gltf = await this.gltfLoader.loadAsync('/model/waterFall2.glb');

    gltf.scene.traverse((obj) => {
      
      
      if( obj.name == 'WaterFall') {
        obj.material.dispose();
        obj.material = this.waterFallMaterial;
      }
      
      if( obj.name == 'Water') {
        obj.material.dispose();
        obj.material = this.waterMaterial;
      }

    })

    gltf.scene.position.y = 0.1;
    this.mesh = gltf.scene;
    return gltf.scene;
  }




  update(time) {
    this.waterFallMaterial.uniforms.uTime.value = time;
    this.waterMaterial.uniforms.uTime.value = time;
  }
}

export default WaterFall;